import { gql } from 'apollo-boost';

const login = gql`
  mutation($email: String!, $password: String!) {
    loginPortal(email: $email, password: $password) {
      jwt
    }
  }
`;

const recoveryPassword = gql`
  mutation($email: String!) {
    recoveryPasswordPortal(email: $email)
  }
`;

const resetPassword = gql`
  mutation($email: String!, $token: String!, $password: String!) {
    resetPasswordPortal(email: $email, token: $token, password: $password)
  }
`;

const currentUser = `
  query {
    currentUserPortal {
      id
      name
      email
      stores
    }
  }
`;

const storeAvailable = gql`
  mutation($storeId: String!, $available: Boolean!) {
    storeAvailablePortal(storeId: $storeId, available: $available)
  }
`;

const editStore = gql`
  mutation($storeId: String!, $data: JSON!) {
    editStorePortal(storeId: $storeId, data: $data)
  }
`;

const editOperatingHours = gql`
  mutation($storeId: String!, $data: JSON!) {
    editOperatingHoursPortal(storeId: $storeId, data: $data) {
      status
    }
  }
`;

const storeRoles = gql`
  query($storeId: String!) {
    storeRolesPortal(storeId: $storeId) {
      roles
    }
  }
`;

const verifyStoreRole = gql`
  mutation($storeId: String!, $email: String!) {
    verifyStoreRolePortal(email: $email, storeId: $storeId)
  }
`;

const addStoreRole = gql`
  mutation($storeId: String!, $email: String!, $roleType: String!) {
    addStoreRolePortal(storeId: $storeId, email: $email, roleType: $roleType)
  }
`;

const addNewStoreRole = gql`
  mutation(
    $storeId: String!
    $roleType: String!
    $name: String!
    $email: String!
    $password: String!
  ) {
    addNewStoreRolePortal(
      storeId: $storeId
      roleType: $roleType
      name: $name
      email: $email
      password: $password
    )
  }
`;

const editStoreRole = gql`
  mutation($storeId: String!, $userId: String!, $roleType: String!) {
    editStoreRolePortal(storeId: $storeId, userId: $userId, roleType: $roleType)
  }
`;

const deleteStoreRole = gql`
  mutation($storeId: String!, $userId: String!) {
    deleteStoreRolePortal(storeId: $storeId, userId: $userId)
  }
`;

const uploadAvatar = gql`
  mutation($id: String!, $avatar: Upload) {
    uploadAvatarPortal(id: $id, avatar: $avatar) {
      avatarUrl
    }
  }
`;

const uploadCover = gql`
  mutation($id: String!, $cover: Upload) {
    uploadCoverPortal(id: $id, cover: $cover) {
      coverUrl
    }
  }
`;

const editUser = gql`
  mutation($id: String!, $email: String!, $password: String!, $newPassword: String!) {
    editUserPortal(id: $id, email: $email, password: $password, newPassword: $newPassword)
  }
`;

const ratings = gql`
  query($storeId: String!, $offset: Int!, $limit: Int!, $orderBy: JSON!) {
    ratingsPortal(storeId: $storeId, offset: $offset, limit: $limit, orderBy: $orderBy) {
      ratings
    }
  }
`;

const replyRating = gql`
  mutation(
    $userId: String!, 
    $storeId: String!, 
    $storeOrderId: String!, 
    $orderId: String!, 
    $ratingId: String!, 
    $ratingReply: String!
  ) {
    replyRatingPortal(
      userId: $userId,
      storeId: $storeId,
      storeOrderId: $storeOrderId, 
      orderId: $orderId, 
      ratingId: $ratingId, 
      ratingReply: $ratingReply
    )
  }
`;

const billingDetails = gql`
  query($storeId: String!) {
    billingDetailsPortal(storeId: $storeId)
  }
`;

const reportsPortal = gql`
  query($storeId: String!, $offset: Int!, $limit: Int!) {
    reportsPortal(storeId: $storeId, offset: $offset, limit: $limit)
  }
`;

const withdrawalsPortal = gql`
  query($storeId: String!, $offset: Int!, $limit: Int!) {
    withdrawalsPortal(storeId: $storeId, offset: $offset, limit: $limit)
  }
`;

const categories = gql`
  query($storeId: String!) {
    categoriesPortal(storeId: $storeId)
  }
`;

const addNewCategory = gql`
  mutation($storeId: String!, $name: String!, $position: Int!) {
    addNewCategoryPortal(storeId: $storeId, name: $name, position: $position)
  }
`;

const reorderCategory = gql`
  mutation($storeId: String!, $categories: [JSON]) {
    reorderCategoryPortal(storeId: $storeId, categories: $categories)
  }
`;

const editCategory = gql`
  mutation($storeId: String!, $categoryId: String!, $name: String!, $visible: Boolean!) {
    editCategoryPortal(storeId: $storeId, categoryId: $categoryId, name: $name, visible: $visible)
  }
`;

const deleteCategory = gql`
  mutation($storeId: String!, $categoryId: String!) {
    deleteCategoryPortal(storeId: $storeId, categoryId: $categoryId)
  }
`;

const uploadMaterialImage = gql`
  mutation($storeId: String!, $image: Upload) {
    uploadMaterialImagePortal(storeId: $storeId, image: $image)
  }
`;

const addNewMaterial = gql`
  mutation($storeId: String!, $data: JSON!) {
    addNewMaterialPortal(storeId: $storeId, data: $data)
  }
`;

const editMaterial = gql`
  mutation($storeId: String!, $materialId: String!, $data: JSON!) {
    editMaterialPortal(storeId: $storeId, materialId: $materialId, data: $data)
  }
`;

const deleteMaterial = gql`
  mutation($storeId: String!, $materialId: String!) {
    deleteMaterialPortal(storeId: $storeId, materialId: $materialId)
  }
`;

const orders = gql`
  query(
    $storeId: String!,
    $status: String!
    $searchBy: String!
    $orderBy: JSON!
    $offset: Int!
    $limit: Int!
  ) {
    ordersPortal(
      storeId: $storeId
      status: $status
      searchBy: $searchBy
      orderBy: $orderBy
      offset: $offset
      limit: $limit
    )
  }
`;

const handleOrderStatus = gql`
  mutation(
    $storeId: String!,
    $orderId: String!,
    $storeOrderId: String!,
    $userId: String!,
    $storeName: String!,
    $status: String!
  ) {
    handleOrderStatusPortal(
      storeId: $storeId, 
      orderId: $orderId,
      storeOrderId: $storeOrderId,
      userId: $userId,
      storeName: $storeName,
      status: $status
    )
  }
`;

const cancelOrder = gql`
  mutation(
    $storeId: String!,
    $wirecardId: String!,
    $orderId: String!,
    $storeOrderId: String!,
    $userId: String!,
    $storeName: String!,
    $reason: String!
  ) {
    cancelOrderPortal(
      storeId: $storeId,
      wirecardId: $wirecardId,
      orderId: $orderId,
      storeOrderId: $storeOrderId,
      userId: $userId,
      storeName: $storeName,
      reason: $reason
    )
  }
`;

const summary = gql`
  query($storeId: String!) {
    summaryPortal(storeId: $storeId)
  }
`;

const publishStore = gql`
  mutation($storeId: String!) {
    publishStorePortal(storeId: $storeId) {
      status
    }
  }
`;

const faq = gql`
  query {
    faqPortal
  }
`;

const sendMessage = gql`
  mutation($storeId: String!, $role: String!, $reason: String!, $name: String!, $phone: String!, $email: String!, $message: String!) {
    sendMessagePortal(storeId: $storeId, role: $role, reason: $reason, name: $name, phone: $phone, email: $email, message: $message)
  }
`;

export {
  login,
  recoveryPassword,
  resetPassword,
  currentUser,
  storeAvailable,
  editStore,
  editOperatingHours,
  storeRoles,
  verifyStoreRole,
  addStoreRole,
  addNewStoreRole,
  editStoreRole,
  deleteStoreRole,
  uploadAvatar,
  uploadCover,
  editUser,
  ratings,
  replyRating,
  billingDetails,
  reportsPortal,
  withdrawalsPortal,
  categories,
  addNewCategory,
  reorderCategory,
  editCategory,
  deleteCategory,
  uploadMaterialImage,
  addNewMaterial,
  editMaterial,
  deleteMaterial,
  orders,
  handleOrderStatus,
  cancelOrder,
  summary,
  publishStore,
  faq,
  sendMessage,
};
